import React from "react";
import { OMSMultiselectDropdown } from "../../../app/common/common-components/OMSMultiselectDropdown";

const PortalAccessTab = ({ state, data, handleCheckboxChangedPortalAccess, handleRoleDD }) => {
  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="form-group manageListings">
            <br />
            <span>Portal settings</span>
            <br />
          </div>
        </div>
      </div>
      {state.UserPortals.map((item, index) => {
        return (
          <div className="row" key={`${item.PortalID}-${index}`}>
            <div className="col-md-12">
              <div className="form-group">
                {data.admin_access ? (
                  <span>
                    <input
                      type="checkbox"
                      id={"chk_" + item.portalID}
                      name={"chk_" + item.portalID}
                      checked={item.isEnabled}
                      onChange={(e) => handleCheckboxChangedPortalAccess(e, index)}
                    />{" "}
                    {item.portalName}
                  </span>
                ) : (
                  <span>
                    <input type="checkbox" readOnly={true} id={"chk_" + item.portalID} name={"chk_" + item.portalID} checked={item.isEnabled} />{" "}
                    {item.portalName}
                  </span>
                )}
              </div>
            </div>
          </div>
        );
      })}
      <div className="row">
        <div className="col-md-6 manageListings">
          <label htmlFor="">Manage listings, contacts and deals for</label>
          <br />
          <OMSMultiselectDropdown
            id="manageListings"
            name="Choose some options..."
            options={state.manageListingsDD}
            valueField="value"
            labelField="text"
            value={state.manageListingsValue}
            onChange={(e) => handleRoleDD(e)}
          />
        </div>
      </div>
    </>
  );
};

export default PortalAccessTab;
